import { StylesConfig } from 'react-select'

// Shared dashboard and archive filters follow the active organisation theme.
export const managerSelectStyles: StylesConfig<{ label: string, value: string }, false> = {
  control: (base, state) => ({
    ...base,
    minHeight: 45,
    height: 45,
    borderRadius: 10,
    boxSizing: 'border-box',
    border: `1px solid ${state.isFocused ? 'var(--careco-primary)' : 'var(--color-input-stroke)'}`,
    boxShadow: state.isFocused ? 'inset 0 0 0 1px var(--careco-primary)' : 'none',
    '&:hover': { borderColor: state.isFocused ? 'var(--careco-primary)' : 'var(--color-input-stroke)' },
  }),
  valueContainer: base => ({ ...base, height: 43, boxSizing: 'border-box', padding: '0 12px' }),
  indicatorsContainer: base => ({ ...base, height: 43 }),
  menu: base => ({ ...base, zIndex: 5 }),
  option: (base, state) => ({
    ...base,
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    overflow: 'hidden',
    backgroundColor: state.isSelected
      ? 'var(--careco-row-alt)'
      : state.isFocused ? 'var(--careco-primary-light)' : base.backgroundColor,
    color: state.isSelected ? '#111827' : base.color,
    cursor: 'pointer',
    '&:active': {
      backgroundColor: 'var(--careco-row-alt)',
    },
    '&:hover': {
      backgroundColor: state.isSelected ? 'var(--careco-row-alt)' : 'var(--careco-primary-light)',
    },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
}

export const qcsManagerSelectStyles: typeof managerSelectStyles = {
  ...managerSelectStyles,
  control: (base, state) => ({
    ...managerSelectStyles.control(base, state),
    minHeight: 44,
    height: 44,
    backgroundColor: '#fff',
  }),
  valueContainer: base => ({ ...base, height: 42, boxSizing: 'border-box', padding: '0 12px', minWidth: 0 }),
  indicatorsContainer: base => ({ ...base, height: 42 }),
  menu: base => ({
    ...base,
    zIndex: 5,
    width: '100%',
    maxWidth: 'calc(100vw - 40px)',
    borderRadius: 8,
    overflow: 'hidden',
  }),
  menuList: base => ({ ...base, padding: 4 }),
  option: (base, state) => ({
    ...managerSelectStyles.option(base, state),
    padding: '10px 12px',
    borderRadius: 6,
  }),
}
